export default "__VITE_ASSET__CTrn7TeJ__"